import { Component, Input, OnInit } from '@angular/core';
import {
  FinancialAccountsStatementsService,
  GroomedMonthlyAccountStatements,
  FinancialAccountStatementsResponse,
} from '@brightside-web/desktop/feature/financial-accounts-core';
import { Observable } from 'rxjs';

@Component({
    selector: 'brightside-web-account-statements',
    templateUrl: './account-statements.component.html',
    styleUrls: ['./account-statements.component.css'],
    standalone: false
})
export class AccountStatementsComponent implements OnInit {
  @Input() accountId: any;
  @Input() statementType: 'monthly' | 'taxes' = 'monthly';
  /** When true, hides the back button and in-modal layout (use when shown inside SimpleGlobalModal). */
  @Input() modalMode = false;

  statements: Observable<GroomedMonthlyAccountStatements[]> = this._statementsService.statements;
  taxStatements: Observable<FinancialAccountStatementsResponse[]> = this._statementsService.taxStatements;
  statementsTitle = '';

  constructor(private _statementsService: FinancialAccountsStatementsService) {}

  ngOnInit(): void {
    if (this.statementType === 'monthly') {
      this._statementsService.getMonthlyStatements();
      this.statementsTitle = 'STATEMENTS_TITLE';
    } else {
      this._statementsService.getTaxStatements();
      this.statementsTitle = 'ACCOUNT_HOME_MENU_TAX_STATEMENTS';
    }
  }

  downloadStatement($event: any, statementItem: FinancialAccountStatementsResponse) {
    this._statementsService.getDateForStatement(statementItem.statementId);
  }
}
